import { get, isEmpty } from 'lodash';
import { useEffect, useState } from 'react';

import Loading from 'components/Loader';

import * as apis from 'apis';
import { useToast } from 'hooks/useToast';
import { useLiff } from 'providers/Liff';
import Context from './Context';

import { ENV_TYPES } from 'configs/constant';
import configs from 'configs/envConfig';
import { isMobile } from 'utils/methods';

const { OA_LINK, STAGE } = configs;

const Provider = ({ children }) => {
    const [liffAuth, setLiffAuth] = useState({});
    const [tpAuth, setTpAuth] = useState({});
    const [fetched, setFetched] = useState(false);
    const { liff, ready } = useLiff();
    const { danger } = useToast();

    const isLoacl = STAGE === ENV_TYPES.LOCAL;

    const getCreateClient = (profile, accessToken) => {
        return apis.getCreateCustomer({ lineId: profile.userId, profile }, accessToken);
    };

    async function getClientProfiles(liff) {
        try {
            const profile = await liff.getProfile().catch((error) => {
                console.error(error);
                liff.logout();
                liff.login({ redirectUri: window.location.href });
                return false;
            });

            if (!profile) return { error: true };

            const profilePlus = liff.getDecodedIDToken() || {};
            const accessToken = liff.getAccessToken();
            const lineId = profile.userId;
            const tpAuth = await getCreateClient(profile, accessToken);
            console.log('tpAuth', tpAuth);
            console.log('accessToken', accessToken);
            if (tpAuth.err || tpAuth.error) return { error: true };
            return { profile, accessToken, profilePlus, lineId, tpAuth: get(tpAuth, 'data', {}) };
        } catch (error) {
            console.log('getClientProfiles', error);

            return { error };
        }
    }

    const getClient = async () => {
        const { profile, accessToken, lineId, error, tpAuth } = await getClientProfiles(liff);
        if (isEmpty(profile) || error) {
            danger('請登入後再試一次');
            if (!isLoacl) return false;
        }
        setLiffAuth({ accessToken, lineId, profile });
        setTpAuth(tpAuth);

        console.log('liffAuth', { accessToken, lineId, profile });
        console.log('tpAuth', tpAuth);

        return { accessToken, lineId, profile };
    };

    const init = async () => {
        const [auth] = await Promise.all([getClient()]);
        if (auth) setFetched(true);
    };

    useEffect(() => {
        console.log(liff, ready);
        if (!liff || !ready) return;

        if (!isLoacl && !isMobile()) return window.location.replace(OA_LINK);
        if (!isLoacl && !liff.isLoggedIn()) return liff.login({ redirectUri: window.location.href });

        if (isEmpty(tpAuth)) init();
    }, [liff, ready]);

    const props = {
        liffAuth,
        tpAuth,
        refreshAuth: getClient,
        setTpAuth
    };

    return <Context.Provider value={{ ...props }}>{fetched ? children : <Loading />}</Context.Provider>;
};

export default Provider;
